import { NavLink, useLocation } from "react-router";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { CustomerName } from "@/shared/components/domain/customer/customer-name";

const sectionInfo: { [key: string]: { label: string; to: string } } = {
  customers: { label: "Kunden", to: "/base-data/customers" },
  companies: { label: "Unternehmen", to: "/base-data/companies" },
  "feature-auth": { label: "Authorisierung", to: "/base-data/feature-auth" },
  "sample-errors": { label: "Probenfehler", to: "/base-data/sample-errors" },
  moulds: { label: "Schimmelpilze", to: "/base-data/moulds" },
  batches: { label: "Chargen", to: "/base-data/batches" },
  airsamplers: { label: "Luftkeimsammler", to: "/base-data/airsamplers" },
};

export function BreadcrumbsToBasedata() {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);
  const section = segments[1];
  const info = section ? sectionInfo[section] : undefined;
  const isCustomerDetail = section === "customers" && segments.length > 2;
  const customerId = isCustomerDetail ? segments[2] : undefined;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem className="hidden md:block">
          <BreadcrumbLink asChild>
            <NavLink to="/base-data/sample-errors">
              <span className="font-mono">Stammdaten</span>
            </NavLink>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {info && (
          <>
            <BreadcrumbSeparator className="hidden md:block" />
            <BreadcrumbItem className="hidden md:block">
              {isCustomerDetail ? (
                <BreadcrumbLink asChild>
                  <NavLink to={info.to}>{info.label}</NavLink>
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage className="text-muted-foreground font-normal">
                  {info.label}
                </BreadcrumbPage>
              )}
            </BreadcrumbItem>
          </>
        )}
        {isCustomerDetail && customerId && (
          <>
            <BreadcrumbSeparator className="hidden md:block" />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-muted-foreground font-normal">
                <CustomerName customerId={customerId} />
              </BreadcrumbPage>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
